/**
 * Returns true when the error looks like a Vite/webpack chunk-load failure
 * (stale chunk hash after deploy, transient network failure after the
 * lazyWithRetry retry budget is exhausted).
 */
export function isChunkLoadError(error: Error): boolean {
  const msg = error.message ?? '';
  const name = error.name ?? '';
  return (
    name === 'ChunkLoadError' ||
    msg.includes('Loading chunk') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Unable to preload CSS') ||
    msg.includes('Lazy-loaded module resolved without a default export')
  );
}
